/**
 * 页面路由tag
 *
 * @date 2019-05-20
 * @author chenyongzheng
 * @type {{routerViews: Array}}
 */

// 引入路由实例
import Router from '../../router/index'

// 引入elementUI MessageBox模块 Message模块
import {Message} from 'element-ui'

// 引入lodash
import lodash from 'lodash'

// 定义常量state 状态对象
const state = {
    // 存储路由array
    routerViews: [],
};


// 定义常量getter 实时监听state值
const getters = {
    /**
     * 获取路由
     * @returns {Array}
     */
    showRouterViews() {
        return state.routerViews;
    }
}
// 定义常量mutations 改变状态值 同步事务
const mutations = {
    /**
     * TODO 下一版需优化下
     *
     * 添加路由array
     * @param state
     */
    addView(state, item) {

        for (let i = 0, len = state.routerViews.length; i < len; i++) {
            if (state.routerViews[i].index == item.index && state.routerViews[i].title == item.title && state.routerViews[i].barFlag == item.barFlag) {
                return;
            }
            if (state.routerViews[i].index == item.index && state.routerViews[i].title != item.title) {
                state.routerViews.splice(i, 1);
            }
        }
        state.routerViews.push(item);
        state.routerViews = lodash.uniqWith(state.routerViews, 'title');

        Router.afterEach((to, from) => {

            let tempDetailFlag = to.path.indexOf('Detail') > -1 && !to.query.id;
            let tempBasicFlag = to.path.indexOf('Basic') > -1 && !to.query.addFlag && !to.query.id;
            if (tempDetailFlag || tempBasicFlag) {
                let tempPath = to.path.substring(1, to.path.length);
                for (let i = 0, len = state.routerViews.length; i < len; i++) {
                    if (state.routerViews[i].index == tempPath) {
                        state.routerViews.splice(i, 1);
                        Router.push({
                            path: from.path
                        })
                        // Message({
                        //     message: '请重新选择',
                        //     type: 'warning'
                        // })
                        return false;
                    }
                }
            }
        })
    },

    /**
     * 删除路由array
     * @param state
     */
    delView(state, item) {
        let index = state.routerViews.indexOf(item);
        if (index !== -1) {
            state.routerViews.splice(index, 1);
        }

        if (state.routerViews.length != 0) {

            for (let i = 0, len = state.routerViews.length; i < len; i++) {

                if (state.routerViews[i].index == item.index) {
                    state.routerViews.splice(i, 1);
                }
            }

            let tempIndex = state.routerViews[state.routerViews.length - 1].index;
            Router.push({
                path: tempIndex
            })
        }


    },

    /**
     * 清空路由array
     * @param state
     */
    clearView(state) {
        state.routerViews = [];
    }
};

// 定义常量actions 改变状态值 异步事务
const actions = {
    /**
     * 添加路由array
     * @param context
     */
    addView(context, item) {
        context.commit('addView', item)
    },

    /**
     * 删除路由array
     * @param context
     */
    delView(context, item) {
        context.commit('delView', item)
    },

    /**
     * 清空路由array
     * @param context
     */
    clearView(context) {
        context.commit('clearView')
    }
};

// 暴露模块
export default {
    //用于在全局引用此文里的方法时标识这一个的文件名
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tagView.js